import { render, staticRenderFns } from "./EntityDataEmails.vue?vue&type=template&id=66f93378&scoped=true"
import script from "./EntityDataEmails.vue?vue&type=script&lang=js"
export * from "./EntityDataEmails.vue?vue&type=script&lang=js"
import style0 from "./EntityDataEmails.vue?vue&type=style&index=0&id=66f93378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f93378",
  null
  
)

export default component.exports